module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/trash-o-883a41ba3d7039e23652910a09a71676.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/trash-o.svg
// module id = OIEp
// module chunks = 24